<div>
    <div class="d-flex justify-content-center mt-2 mb-1">
        <h6>Verfügbarkeit</h6>
    </div>
</div>
<div>
    <div>
        <canvas class="avs-dashboard-canvas" id="workload">{{ chart }}</canvas>
    </div>
</div>